export default {
  metadata: {
    version: '1.0.0',
    id: 'menu-block-1.0.0',
    name: 'JDSMenuBlock'
  },
  hierarchy: {
    popup: [
      {
        'popup-container': ['jds_menu_block_internal']
      }
    ]
  },
  base: {
    popup: {
      'background-color': '{global.transparent}',
      priority: 70,
      passive: true
    },
    'popup-container': {
      'flex-direction': '{flexDirection.stack}',
      overflow: 'auto',
      'max-height': '{m_7}'
    },
    jds_menu_block_internal: {
      hidden: false
    }
  },
  variant: {
    open: {
      true: {
        popup: {
          passive: false
        },
        jds_menu_block_internal: {
          open: true
        }
      }
    }
  },
  combination: [{}],
  combination_config: [[]],
  api: {
    config: {
      open: {
        values: [false, true],
        doc_description: 'Used to open or close the modal programatically.'
      }
    },
    data: {
      'popup-container': {
        'padding-left': {
          type: 'size',
          name: 'offsetX',
          function: true
        },
        'padding-top': {
          type: 'size',
          name: 'offsetY',
          function: true
        }
      },
      jds_menu_block_internal: {
        maxHeight: {
          type: 'size',
          name: 'maxHeight',
          function: true
        },
        maxWidth: {
          type: 'size',
          name: 'maxWidth'
        },
        minWidth: {
          type: 'size',
          name: 'minWidth',
          function: true
        },
        items: {
          type: 'list',
          name: 'items',
          doc_description:
            'Each entry eithin Menu is configured throught the MenuItem object. Some type may be unselectable.',
          object: {
            type: 'JDSMenuBlockItem.type',
            label: 'string',
            value: 'string',
            prefix: 'icon',
            suffix: 'icon',
            disabled: 'boolean'
          }
        },
        selectedIndex: {
          type: 'number',
          name: 'selectedIndex',
          doc_description:
            'Used to programatically change current selected Index'
        },
        'items.type': {
          type: 'string',
          name: 'items.type'
        },
        'items.label': {
          type: 'string',
          name: 'items.label'
        },
        'items.value': {
          type: 'string',
          name: 'items.value'
        },
        'items.prefix': {
          type: 'icon',
          name: 'items.prefix'
        },
        'items.suffix': {
          type: 'icon',
          name: 'items.suffix'
        },
        'items.disabled': {
          type: 'boolean',
          name: 'items.disabled'
        }
      }
    },
    events: {
      jds_menu_block_internal: {
        onSelect: {
          name: 'onSelect',
          doc_description:
            'onClick event that triggers upon click or tap of the chosen entry.'
        },
        onAppear: {
          name: '_onAppear',
          platform: 'ios'
        },
        onClick: 'onClick'
      },
      popup: {
        onClick: 'onClose'
      }
    },
    a11y: {
      jds_menu_block_internal: {
        name: 'items',
        repeating: {
          ariaLabel: 'itemAriaLabel',
          ariaDescribedby: {
            name: 'itemAriaDescribedby',
            platform: 'web,ios'
          }
        }
      }
    }
  }
};
